import { Routes } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  { path: 'login', loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent) },
  {
    path: 'dashboard', loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent), canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'crawler', pathMatch: 'full' },
      { path: 'crawler', loadComponent: () => import('./features/crawler/crawler.component').then(m => m.CrawlerComponent) },
      { path: 'locations', loadComponent: () => import('./features/locations/locations.component').then(m => m.LocationsComponent) },
      { path: 'spots', loadComponent: () => import('./features/spots/spots.component').then(m => m.SpotsComponent) },
      { path: 'menus', loadComponent: () => import('./features/menus/menus.component').then(m => m.MenusComponent) },
      { path: 'experiences', loadComponent: () => import('./features/experiences/experiences.component').then(m => m.ExperiencesComponent) },
      { path: 'social-media', loadComponent: () => import('./features/social-media/social-media.component').then(m => m.SocialMediaComponent) },
    ]
  }

]
